export default __webpack_public_path__ + "locales/sk/SalesDepartmentRequestDialog.json?hash=978fb850b5d8f99e2f0f05f4ec5b3a59";